import { useNavigate } from "react-router-dom";
import { Wand2, ArrowLeft, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

// Halaman placeholder untuk fitur yang sedang dikembangkan.
// Ditampilkan ke pengguna biasa saat membuka /ai-prewedding langsung dari URL,
// supaya akses tidak membocorkan fitur setengah jadi.
export default function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] grid place-items-center p-6" data-testid="coming-soon-page">
      <Card className="max-w-md w-full p-8 rounded-2xl text-center border-border/60 bg-card/80 backdrop-blur-sm">
        <div className="h-14 w-14 mx-auto rounded-2xl bg-amber-500/15 grid place-items-center mb-5 relative">
          <Wand2 className="h-7 w-7 text-amber-600 dark:text-amber-400" />
          <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-primary text-primary-foreground text-[10px] font-bold grid place-items-center">
            <Sparkles className="h-3 w-3" />
          </span>
        </div>

        <span className="inline-block mb-3 rounded-full border border-amber-500/30 bg-amber-500/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-amber-700 dark:text-amber-300">
          Dalam Pengembangan
        </span>

        <h1 className="font-serif text-3xl mb-3">AI Prewedding Studio</h1>
        <p className="text-muted-foreground text-sm leading-relaxed mb-6">
          Fitur ini sedang kami kembangkan. Nantinya Anda dapat menghasilkan foto prewedding secara
          otomatis dari foto Anda berdua, lengkap dengan pilihan tema dan pose. Mohon tunggu kabar
          selanjutnya, ya.
        </p>

        <Button
          variant="outline"
          className="rounded-full"
          onClick={() => navigate("/dashboard")}
          data-testid="coming-soon-back"
        >
          <ArrowLeft className="h-4 w-4 mr-1.5" />
          Kembali ke Beranda
        </Button>
      </Card>
    </div>
  );
}
